'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(ActiveBlockReason2) {
  ActiveBlockReason2["UserNotVerified"] = "USER_NOT_VERIFIED";
})(exports.ActiveBlockReason || (exports.ActiveBlockReason = {}));
(function(ActiveBlockReasonId2) {
  ActiveBlockReasonId2[ActiveBlockReasonId2["MultipleAccounts"] = 4] = "MultipleAccounts";
  ActiveBlockReasonId2[ActiveBlockReasonId2["BonusAbuse"] = 5] = "BonusAbuse";
  ActiveBlockReasonId2[ActiveBlockReasonId2["SuspectedFruad"] = 6] = "SuspectedFruad";
  ActiveBlockReasonId2[ActiveBlockReasonId2["ConfirmedFraud"] = 7] = "ConfirmedFraud";
  ActiveBlockReasonId2[ActiveBlockReasonId2["FalseRegistration"] = 8] = "FalseRegistration";
  ActiveBlockReasonId2[ActiveBlockReasonId2["Underage"] = 9] = "Underage";
  ActiveBlockReasonId2[ActiveBlockReasonId2["Other"] = 10] = "Other";
  ActiveBlockReasonId2[ActiveBlockReasonId2["UserNotVerified"] = 15] = "UserNotVerified";
  ActiveBlockReasonId2[ActiveBlockReasonId2["PoliticallyExposedPerson"] = 48] = "PoliticallyExposedPerson";
})(exports.ActiveBlockReasonId || (exports.ActiveBlockReasonId = {}));
